import React, { Component } from "react";
import "./index.css";
import { Icon } from "semantic-ui-react";
import { Link } from "redux-little-router";
import { connect } from "react-redux";
import { selectUser } from "../../util/selectors";
import { constructUserProfilePath } from "../../util/index";

class Navbar extends Component {
  render() {
    const firstName = this.props.user.name.split(" ")[0];
    const { uid: id, username } = this.props.user;
    const profileUrl = constructUserProfilePath({ username, id });
    return (
      <nav className="navigation-wrapper">
        <div className="-nav-inner">
          <Link href="/" className="-link" activeProps={{ className: "-active" }}>
            <Icon name="home" size="large" />
            <p className="-title">Home</p>
          </Link>
          <Link href="/newcase" className="-link" activeProps={{ className: "-active" }}>
            <Icon name="add" size="large" />
            <p className="-title">New Case</p>
          </Link>
          <Link href={profileUrl} className="-link" activeProps={{ className: "-active" }}>
            <Icon name="user" size="large" />
            <p className="-title">{firstName}</p>
          </Link>
        </div>
      </nav>
    );
  }
}
const mapStateToProps = state => ({
  user: selectUser(state),
});
export default connect(mapStateToProps)(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar/index.js